import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';

export interface IndividualPayPalMerchantAccount {
  id: number;
  // Null until PayPal's webhook reports the merchant finished onboarding in Business Manager.
  payerId: string | null;
  // Set from PayPal's capabilities webhook; a store routed to an account that is not ready
  // cannot take PayPal payments.
  transactionsReady: boolean;
  assignedStoreCount: number;
}

export interface PayPalMerchantAccountsForBusiness {
  merchantAccounts: IndividualPayPalMerchantAccount[];
}

export const getPayPalMerchantAccounts = (
  businessId: number,
): AxiosPromise<PayPalMerchantAccountsForBusiness> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/businesses/${businessId}/paypal-merchant-accounts`,
  });
};
